import React from 'react';
import './Legal.css';

const TermsOfService = () => {
    return (
        <div className="legal-container">
            <div className="legal-content">
                <h1>Terms of Use – Echonote</h1>
                
                <h2>Introduction</h2>
                <p>
                    Welcome to Echonote ("the Service"), operated by BOCO, a sole proprietorship registered in France by Fabien BOCO (SIRET 89531108200021), registered at 895 311 082 R.C.S. Foix. Business address: Saverdun, 09700, France. By accessing or using Echonote, you agree to comply with and be bound by these Terms of Use. Please review them carefully.
                </p>

                <h2>1. Definitions</h2>
                <p><strong>Service:</strong> Echonote, a web-based application that allows users to record audio and convert it into written notes, to-do lists, and other formats using AI.</p>
                <p><strong>User/You:</strong> Any individual or entity using Echonote.</p>
                <p><strong>We/Us/Our:</strong> Echonote and its owner/operator, Fabien BOCO.</p>
                <p><strong>Terms:</strong> These Terms of Use.</p>

                <h2>2. Acceptance of Terms</h2>
                <p>By accessing or using Echonote, you agree to these Terms. If you do not agree, please do not use the Service.</p>

                <h2>3. Modifications to Terms</h2>
                <p>We reserve the right to modify these Terms at any time. Updates will be posted on our website and become effective immediately. Your continued use of the Service after changes constitutes acceptance of the new Terms.</p>

                <h2>4. Description of Service</h2>
                <p>Echonote enables users to:</p>
                <ul>
                    <li>Record audio via our web application.</li>
                    <li>Convert audio to written notes, to-do lists, and personalized notes using AI (OpenAI Whisper and GPT).</li>
                    <li>Access, manage, and delete audio files and associated notes via your user account.</li>
                    <li>Choose whether to automatically save audio files on our servers. This setting can be disabled at any time.</li>
                </ul>

                <h2>5. User Responsibilities</h2>
                <p><strong>Account Security:</strong> You are responsible for keeping your login details secure. Passwords are stored encrypted.</p>
                <p><strong>Accurate Information:</strong> You agree to provide accurate information during registration and payment.</p>
                <p><strong>Lawful Use:</strong> You agree to use the Service only for lawful purposes.</p>
                <p><strong>Account Management:</strong> You may access, modify, or delete your account and all associated data at any time via your user dashboard.</p>

                <h2>6. Third-Party Integrations</h2>
                <p><strong>AI Processing:</strong> Audio files are sent to OpenAI (Whisper & GPT) for transcription and note generation. See OpenAI's Privacy Policy for more details.</p>
                <p><strong>Payments:</strong> All payments are processed securely through Stripe. No payment details are stored on Echonote servers.</p>
                <p><strong>Analytics & Tracking:</strong> The Service uses Google Analytics, Facebook Pixel, and TikTok Pixel to analyze usage and improve services. See respective platforms for their privacy and data policies.</p>
                <p><strong>Authentication:</strong> You may sign up or log in using Google or via traditional email/password.</p>

                <h2>7. Payments and Refunds</h2>
                <p><strong>Subscription Plans:</strong> Access to the Service requires a paid subscription (monthly or yearly).</p>
                <p><strong>Non-Refundable:</strong> All payments are non-refundable, except in case of major technical errors preventing service use (at our discretion).</p>
                <p><strong>Cancellation:</strong> You may cancel your subscription at any time. Cancellation stops future billing but does not refund current charges.</p>

                <h2>8. Data Privacy and Security</h2>
                <p><strong>Data Storage:</strong> By default, your audio files and notes are stored securely on our servers. You may disable automatic audio file saving at any time.</p>
                <p><strong>Access & Deletion:</strong> You may access or delete your audio files and account data at any time. Upon account deletion, all your data is permanently erased.</p>
                <p><strong>Developer Access:</strong> Our developers may access data strictly for support and debugging purposes.</p>

                <h2>9. Communications</h2>
                <p><strong>Email List:</strong> By registering, you are automatically subscribed to our email list. You may unsubscribe at any time via a link in our emails.</p>
                <p><strong>Contact:</strong> For support or questions, contact us at <a href="mailto:contact@echonote.xyz">contact@echonote.xyz</a>.</p>

                <h2>10. Termination and Transfer</h2>
                <p>We reserve the right to suspend or terminate the Service at any time, for any reason, without notice. In the event of business transfer or sale, these Terms will apply to the new owner/operator.</p>

                <h2>11. Limitation of Liability</h2>
                <p>Echonote is provided "as is" and "as available." We do not warrant uninterrupted, secure, or error-free service. To the maximum extent permitted by law, we are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the Service.</p>

                <h2>12. Governing Law</h2>
                <p>These Terms are governed by the laws of France. Any disputes will be subject to the exclusive jurisdiction of the courts of France.</p>

                <h2>Contact Information</h2>
                <p>For any questions about these Terms, please contact us at <a href="mailto:contact@echonote.xyz">contact@echonote.xyz</a>.</p>
            </div>
        </div>
    );
};

export default TermsOfService; 